export default {
  blobsasurl: "https://teammodeltest.blob.core.windows.net/ht-sharing/",
  blobDomain: {
      global: "https://teammodel.blob.core.windows.net",
      globalrc: "https://teammodel.blob.core.windows.net",
      globaltest: "https://teammodeltest.blob.core.windows.net",
      cn: "https://teammodelos.blob.core.chinacloudapi.cn",
      cnrc: "https://teammodelos.blob.core.chinacloudapi.cn",
      cntest: "https://teammodeltest.blob.core.chinacloudapi.cn",
  },
  shortUrlHost:{
    global: "https://hiteach.cc/",
    globalrc: "https://hiteach.cc/",
    globaltest: "https://hiteach.cc/",
    cn: "https://hiteach.cn/",
    cnrc: "https://hiteach.cn/",
    cntest: "https://hiteach.cn/",
  },
  apiUrl: {
    global: "https://api2.teammodel.net",
    globalrc: "https://api2.teammodel.net",
    globaltest: "https://api2-rc.teammodel.net",
    cn: "https://api2.teammodel.cn",
    cnrc: "https://api2.teammodel.cn",
    cntest: "https://api2-rc.teammodel.cn",
  },
  api2Alpha:{ // 目前只有一個站點，主要是fluidRelay token, endpoint
    global: "https://api2.teammodel.net",
    globalrc:"https://api2.teammodel.net",
    cn: "https://api2.teammodel.cn",
    cnrc: "https://api2.teammodel.cn",
  },
  accountUrl: {
    global: "https://account.teammodel.net",
    globalrc: "https://account.teammodel.net",
    globaltest: "https://account-rc.teammodel.net",
    cn: "https://account.teammodel.cn",
    cnrc: "https://account.teammodel.cn",
    cntest: "https://account-rc.teammodel.cn",
  },
  //clientID: { //HTCommunity
  //  global: "4a6fd5c8-dfe2-4aef-ad9c-d5cb04488ae3",
  //  cn: "06113516-efe3-43ce-ba7e-6b9fcf8776db",
  //},
  clientID: { //Sharing
    global: "8e4c206f-5fb1-454e-9159-e628161c72bc",
    globalrc: "8e4c206f-5fb1-454e-9159-e628161c72bc",
    globaltest: "8e4c206f-5fb1-454e-9159-e628161c72bc",
    cn: "7af86c7c-d90f-47dd-bb08-49c2bcc0940b",
    cnrc: "7af86c7c-d90f-47dd-bb08-49c2bcc0940b",
    cntest: "7af86c7c-d90f-47dd-bb08-49c2bcc0940b",
  },
  //clientsecret: { //HTCommunity
  //  global: "qWN8Q~GO.rZp4zRsbOJrVGVNuI9M4b-1lqcp2beQ",
  //  globalrc:"qWN8Q~GO.rZp4zRsbOJrVGVNuI9M4b-1lqcp2beQ",
  //  cn: "UfHu3_~Qe9Ps1w~r-lICqCtNjoo7dH4Jp8",
  //  cnrc: "UfHu3_~Qe9Ps1w~r-lICqCtNjoo7dH4Jp8",
  //},
  htCommunityUrl: {
    global: "https://HTCommunity.teammodel.net",
    // cn: "https://account.teammodel.cn",
    globalrc: "https://htcommunity-rc.teammodel.net",
  },
  sharingUrl: {
      global: "https://sharing.teammodel.net",
      globalrc: "https://sharing-rc.teammodel.net",
      globaltest: "https://sharing-test.teammodel.net",
      cn: "https://sharing.teammodel.cn",
      cnrc: "https://sharing-rc.teammodel.cn",
      cntest: "https://sharing-test.teammodel.cn",
  },
  ies5ApiUrl: {
    global: "https://www.teammodel.net",    
    globalrc: "https://ies5-rc.teammodel.net",
    globaltest: "https://test.teammodel.net",
    cn: "https://www.teammodel.cn",
    cnrc: "https://rc.teammodel.cn",
    cntest: "https://test.teammodel.cn",
  },
};
